import { CalculatorResultWrapper } from '../../../models/analysis/calculator-result-wrapper';

export class PowerPlantRequestData {
  analysisId?: string;
  projectName: string;
  investorName?: string;
  productionToolName: string;
  consumptionInputMethod: string;
  priceID: string;
  conclusion?: string;
  address: string;
  language?: string;
  expanded?: boolean;

  constructor(calculatorResultWrapper: CalculatorResultWrapper, requestData: ProjectRequestData) {
    this.priceID = calculatorResultWrapper.request?.priceID || '';
    this.productionToolName = calculatorResultWrapper.request?.siteDataInputType || calculatorResultWrapper.productionType || '';
    this.consumptionInputMethod = calculatorResultWrapper.consumptionInputMethod;

    this.projectName = requestData.projectName;
    this.investorName = requestData.investorName;
    this.conclusion = requestData.conclusion;
    this.address = requestData.address;
    this.language = requestData.language;
    this.analysisId = requestData.analysisId;
    this.expanded = requestData.expanded;
  }
}

export interface ProjectRequestData {
  projectName: string;
  address: string;
  language?: string;
  analysisId?: string;
  investorName?: string;
  conclusion?: string;
  expanded?: boolean;
}
